import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment-timezone";

@Pipe({
  name: 'clockTime'
})
export class ClockTimePipe extends DatePipe implements PipeTransform {

  // Overloads (IMPORTANT)
  transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string | null;
  transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;

  // Implementation
  transform(
    value: string | number | Date | null | undefined,
    format: string = "MM/dd/yyyy h:mm a",
    timezone: string = "America/New_York",
    locale?: string
  ): string | null {

    if (value == null) return null;

    const m = moment.tz(value, timezone);

    if (!m.isValid()) return null;

    return super.transform(m.toDate(), format, undefined, locale);
  }


}
